import {
	createOrganizationCounselor,
	removeOrganizationCounselor,
	updateOrganizationCounselorRole,
} from 'api/admin'
import { resolveRoleIdForAccessLabel } from './userManagementMapping'

export async function updateCounselorAccessLevel({ counselorId, accessLabel, roles }) {
	const id = String(counselorId || '').trim()
	if (!id) throw new Error('counselorId is required')
	const roleId = resolveRoleIdForAccessLabel(roles, accessLabel)
	return updateOrganizationCounselorRole({ counselorId: id, roleId })
}

export async function createCounselorInOrganization({ name, email, accessLabel, roles }) {
	const counselorName = String(name || '').trim()
	const counselorEmail = String(email || '').trim()
	if (!counselorName) throw new Error('name is required')
	if (!counselorEmail) throw new Error('email is required')
	const roleId = resolveRoleIdForAccessLabel(roles, accessLabel)
	return createOrganizationCounselor({
		name: counselorName,
		email: counselorEmail,
		role_id: roleId,
	})
}

export async function removeCounselorFromOrganization(counselorId) {
	const id = String(counselorId || '').trim()
	if (!id) throw new Error('counselorId is required')
	return removeOrganizationCounselor(id)
}
